import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import { FilterContainsInsensitive } from "../common/FilterCondition";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import Auth from "src/auth";
import {
  CommonSearchExtra,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";

const PendingApprovalList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  // eslint-disable-next-line no-unused-vars
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("emailId"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // Your default search model
  const SearchFilterModel = {
    emailId: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getBidderList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    setloading(true);
    resetPageLimit(0);
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getBidderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getBidderList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  const fields = [
    {
      key: "emailId",
      _style: { width: "15%" },
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "mobile",
      label: TableHeaderSet("Mobile", "mobile"),
    },
    {
      key: "username",
      label: TableHeaderSet("Username", "username"),
    },

    {
      key: "show_details",
      label: <div>View</div>,
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";

    filter = FilterContainsInsensitive(filter, "emailId", search.emailId);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`User/GetPendingApproval?${filterManage()}`).then(
        (res) => {
          if (res.success)
            paggingDisabledManage(parseInt(res.data.length) || 0);
        }
      );
    }
  };
  const getBidderList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `User/GetPendingApproval?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };

  const searchControl = (
    <>
      <SCInput
        label="Email Address:"
        name={"name"}
        value={search.name}
        onChange={updateSearch}
      />
    </>
  );
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
    />
  );
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Pending Users Approval"
      loading={loading}
      path="/pendingapprovalview/"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      tabBtn="View"
      id="userid"
    />
  );
};

export default PendingApprovalList;

// Bidder/getBidders?$orderBy=emailId%20desc&$skip=3&$top=10
//   Bidder/getBidders?$filter=contains(emailId,'{aa}')%20emailId%20asc%20&$skip=0&$top=5
//  Bidder/getBidders?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${5}
